import React, { useContext, useState } from 'react'
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  MenuItem,
} from '@mui/material'
import { Form } from 'react-final-form'
import { Select, TextField } from 'mui-rff'
import { usePostClaimStaffBenefit } from '../../api/staff-benefit-claim'
import { useSnackbar } from 'notistack'
import { StaffBenefitClaimContext } from '../../pages/StaffBenefitUserPanelScreen'
import { useAuth } from '../../api/context/UserAuthContext'
import { regionalState } from '../../constant/regional-state'
import FileField from '../shared/component/FileField'
import axios from 'axios'

const SUPPORTED_FORMATS = ['image/png', 'image/jpeg', 'image/jpg']

export const ClaimDialog = (props) => {
  const { openClaim, onClose, staffBenefit } = props
  const { mutateAsync, isLoading } = usePostClaimStaffBenefit()
  const { enqueueSnackbar } = useSnackbar()
  const { refetch } = useContext(StaffBenefitClaimContext)

  const [submitIsLoading, setSubmitIsLoading] = useState(false)

  const { user } = useAuth()

  const handleCancel = () => {
    onClose()
  }

  const onSubmit = async (values) => {
    setSubmitIsLoading(true)
    const file = values?.invoice?.[0]

    let formData, uploadRes
    if (file) {
      formData = new FormData()
      formData.append('staffBenefitInvoice', file, file?.name ?? '')

      uploadRes = await axios({
        url: `/api/upload/staff-benefit-invoice`,
        method: 'POST',
        data: formData,
      })
    }

    const res = await mutateAsync({
      ...values,
      staffBenefitId: staffBenefit.id,
      user: user.id,
      invoiceImg: uploadRes?.data,
    }).catch((e) => {
      if (e?.response?.data?.errors) {
        enqueueSnackbar(e?.response?.data?.errors[0]?.msg, {
          variant: 'error',
        })
      } else {
        enqueueSnackbar(e?.response?.data?.message ?? 'Fail to submit claim', {
          variant: 'error',
        })
      }
    })
    if (res?.status === 200) {
      enqueueSnackbar('Claim is submitted. Pending approval from admin.', {
        variant: 'success',
      })
      refetch()
      onClose()
    }
    setSubmitIsLoading(false)
  }

  const validate = (values) => {
    const errors = {}
    if (!values.regionalState) {
      errors.regionalState = 'Required'
    }

    if (!values.quantity) {
      errors.quantity = 'Required'
    }
    if (values.quantity <= 0) {
      errors.quantity = 'Quantity must be more than or equal to 1'
    }

    return errors
  }

  return (
    <Dialog maxWidth='xs' open={openClaim} PaperProps={{ style: { width: '100%' } }}>
      <Form
        onSubmit={onSubmit}
        validate={validate}
        keepDirtyOnReinitialize //let data stay on the form
        initialValues={{ quantity: 1 }}
        component={({ handleSubmit, submitting }) => (
          <form
            onSubmit={handleSubmit}
            style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}
          >
            <DialogTitle id='claim-staff-benefit'>
              Claim Staff Benefit ({staffBenefit.name ?? ''})
            </DialogTitle>
            <DialogContent dividers>
              <Box
                display='flex'
                flexDirection='column'
                justifyContent='space-between'
                minHeight={500}
              >
                <Select
                  name='regionalState'
                  label='Regional State'
                  formControlProps={{ margin: 'none' }}
                  required
                >
                  {Object.keys(regionalState).map((each) => (
                    <MenuItem value={regionalState[each]}>{regionalState[each]}</MenuItem>
                  ))}
                </Select>

                <TextField label='Quantity' name='quantity' required />
                <TextField label='Car Plate' name='carPlate' required />
                <TextField label='Car Model' name='carModel' required />
                <TextField label='Supplier' name='supplier' />

                <FileField
                  name='invoice'
                  label='Invoice'
                  helperText='File size must be less than 1MB'
                  required
                  accept={SUPPORTED_FORMATS}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button variant='outlined' onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                color='primary'
                variant='contained'
                type='submit'
                disabled={submitting || isLoading || submitIsLoading}
              >
                {(isLoading || submitIsLoading) && <CircularProgress size='1rem' />}
                Submit
              </Button>
            </DialogActions>
          </form>
        )}
      />
    </Dialog>
  )
}
